export default (state, adminTabIndex = 0) => ({ adminTabIndex });
